import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiLicenseStatusComponent } from '@components/shared/license/ui-license-status.component';
import { DirectivesModule } from '@directives/directives.module';
import { MatTooltipModule } from '@directives/ui-tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ChartColorService } from '@services';
import { UiDateFormatModule } from '@uipath/angular/directives/ui-dateformat';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        DirectivesModule,
        MatTooltipModule,
        UiDateFormatModule,
    ],
    providers: [
        ChartColorService,
    ],
    declarations: [
        UiLicenseStatusComponent,
    ],
    exports: [
        UiLicenseStatusComponent,
    ],
})
export class UiLicenseStatusModule { }
